import { render } from "./SzCellRevoke.vue?vue&type=template&id=29ae7992&scoped=true"
import script from "./SzCellRevoke.vue?vue&type=script&lang=ts"
export * from "./SzCellRevoke.vue?vue&type=script&lang=ts"

import "./SzCellRevoke.vue?vue&type=style&index=0&id=29ae7992&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-29ae7992"

export default script